<template>
  <div>
    <university-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.university_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import UniversityIndex from "./UniversityIndex";
import { UniversityDivisionService } from "../../services/universityDivision.service";
import { NationService } from "../../services/nation.service";
import { mapGetters, mapMutations } from "vuex";
import { UniversityTypeService } from "../../services/universityType.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "university",
      formSearch: [
        {
          label: this.$t("university.name"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("university.university_division_name"),
          name: "university_division_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("university.nation"),
          name: "country_alpha_two_code",
          value: "",
          type: "select2",
          options: []
        },
        {
          label: this.$t("university.university_type_name"),
          name: "university_type_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("university.id"),
        avatar: this.$t("university.avatar"),
        name: this.$t("university.name"),
        address: this.$t("university.address"),
        nation: this.$t("university.nation"),
        created_at: this.$t("university.created_at"),
        updated_at: this.$t("university.updated_at")
      }
    };
  },
  components: { UniversityIndex },
  methods: {
    ...mapMutations({
      setNationOptions: "SET_NATION_OPTIONS"
    }),
    async getUniversityDivisionOptions() {
      const response = await new UniversityDivisionService().getList();
      this.formSearch[1].options = response.data;
    },
    async getUniversityTypeOptions() {
      const response = await new UniversityTypeService().getList();
      this.formSearch[3].options = response.data;
    },
    async getNation() {
      // if (this.nationsOptions && this.nationsOptions.length > 0) {
      //   console.log('this.nationsOptions', this.nationsOptions);
      //   this.formSearch[2].options = this.nationsOptions;
      //   return;
      // }
      const response = new NationService().getListPublic();
      console.log(response);
      let nations = response.data;
      let nationOptions = [];
      nations.forEach(nation => {
        nationOptions.push({
          id: nation.alpha2Code,
          text: nation.name,
          country_alpha_three_code: nation.alpha3Code
        });
      });
      this.formSearch[2].options = nationOptions;
      this.setNationOptions(nationOptions);
    }
  },
  mounted() {
    this.getUniversityDivisionOptions();
    this.getUniversityTypeOptions();
    this.getNation();
  },
  computed: {
    ...mapGetters({ nationsOptions: "nationsOptions" })
  }
};
</script>
